(() => {
  const source = document.getElementById('PeakStyleNavigationI18n');
  if (!source || typeof window.PeakStyleNavigationI18n?.url === 'function') return;
  let config;
  try { config = JSON.parse(source.textContent); } catch { return; }
  const locale = config.locale || document.documentElement.lang || 'de';
  const root = String(config.root || '/').replace(/\/$/, '');
  const languages = config.languages || ['de', 'en', 'fr', 'it', 'es', 'nl'];
  const languagePrefix = new RegExp('^/(?:' + languages.join('|') + ')(?:-[a-z]{2})?(?=/|$)', 'i');
  const decode = (value) => { try { return decodeURIComponent(value); } catch { return value; } };
  const decodeHtmlEntities = (value) => {
    if (typeof value !== 'string' || !value.includes('&')) return value;
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
  };
  Object.keys(config.ui || {}).forEach((key) => {
    config.ui[key] = decodeHtmlEntities(config.ui[key]);
  });
  Object.values(config.collections || {}).forEach((entry) => {
    if (entry && typeof entry.label === 'string') entry.label = decodeHtmlEntities(entry.label);
  });
  const pathKey = (value) => decode(String(value || '').replace(languagePrefix, '')).replace(/\/$/, '') || '/';
  const origins = new Set([window.location.origin]);
  [config.shop_url, config.permanent_domain].filter(Boolean).forEach((host) => {
    try { origins.add(new URL(host.includes('://') ? host : 'https://' + host).origin); } catch {}
  });
  const collectionPaths = new Map();
  Object.entries(config.collections || {}).forEach(([handle, entry]) => {
    entry.handle = handle;
    collectionPaths.set(pathKey('/collections/' + handle), entry);
    try { collectionPaths.set(pathKey(new URL(entry.url, window.location.origin).pathname), entry); } catch {}
  });
  const currentPreview = new URLSearchParams(window.location.search).get('preview_theme_id');
  const readUrl = (raw) => { try { return new URL(raw, window.location.origin); } catch { return null; } };
  const collection = (raw) => {
    const parsed = readUrl(raw);
    return parsed && origins.has(parsed.origin) ? collectionPaths.get(pathKey(parsed.pathname)) : null;
  };
  const url = (raw) => {
    if (!raw || String(raw).startsWith('#')) return raw;
    const parsed = readUrl(raw);
    if (!parsed || !origins.has(parsed.origin)) return raw;
    const entry = collectionPaths.get(pathKey(parsed.pathname));
    let target = entry ? readUrl(entry.url) : parsed;
    if (!target) return raw;
    const bare = pathKey(target.pathname);
    if (bare === '/collections/all') target = readUrl(config.all_url || '/collections/all');
    if (bare === '/search') target = readUrl(config.search_url || '/search');
    const barePath = target.pathname.replace(languagePrefix, '');
    target.pathname = root + (barePath.startsWith('/') ? barePath : '/' + barePath);
    target.search = parsed.search;
    target.hash = parsed.hash;
    if (currentPreview && !target.searchParams.has('preview_theme_id')) target.searchParams.set('preview_theme_id', currentPreview);
    return target.pathname + target.search + target.hash;
  };
  const refreshUI = () => {
    const settings = document.getElementById('PeakStyleNavigationUI');
    if (!settings) return;
    try {
      Object.entries(JSON.parse(settings.textContent)).forEach(([key, value]) => {
        if (typeof value === 'string' && value.trim()) config.ui[key] = decodeHtmlEntities(value);
      });
    } catch {}
  };
  refreshUI();
  const ui = (key) => config.ui?.[key] || '';
  const label = (raw, fallback = '') => collection(raw)?.label || fallback;
  const node = (entry) => {
    const handle = config.tags?.[entry.tag];
    const translated = handle ? config.collections?.[handle] : collection(entry.url || '/collections/' + (entry.handle || ''));
    const result = { ...entry };
    if (translated) {
      const safeLabel = String(translated.label || '').trim() || String(entry.label || entry.title || '').trim();
      result.title = safeLabel;
      result.label = safeLabel;
      result.url = url(translated.url || entry.url);
    } else if (entry.url) result.url = url(entry.url);
    if (entry.children) result.children = entry.children.map(node);
    return result;
  };
  const tree = (entries) => entries?.forEach((entry) => Object.assign(entry, node(entry)));
  const audienceKey = 'filter.p.m.custom.audience_reference';
  const audience = (raw) => {
    const values = readUrl(raw)?.searchParams.getAll(audienceKey).flatMap((value) => value.split(',')) || [];
    if (values.includes('gid://shopify/Metaobject/107696062552')) return 'damen';
    if (values.includes('gid://shopify/Metaobject/107696095320')) return 'herren';
    if (values.some((value) => ['gid://shopify/Metaobject/107696160856', 'gid://shopify/Metaobject/107696193624', 'gid://shopify/Metaobject/107696291928'].includes(value))) return 'kinder';
    return '';
  };
  const branchKey = (item) => {
    if (item.dataset.psMenuKey) return item.dataset.psMenuKey;
    const direct = item.querySelector(':scope > a[href], :scope > collapsible-tab > a[href], :scope > collapsible-tab > .f-mobile-nav__item-header > a[href]');
    const href = direct?.getAttribute('href');
    const targetAudience = audience(href);
    if (targetAudience) return targetAudience;
    const handle = collection(href)?.handle;
    if (handle === 'bekleidung' || handle === 'schuhe') return handle;
    if (handle === 'ausruestung') return 'ausrustung';
    if (handle === 'sale-25' || /^tag-sale/.test(handle || '')) return 'sale';
    const descendants = [...item.querySelectorAll('a[href]')].map((anchor) => collection(anchor.getAttribute('href'))?.handle || '');
    if (descendants.some((h) => h.startsWith('activity-'))) return 'activity';
    if (descendants.some((h) => h.startsWith('brand-'))) return 'marken';
    const children = [...item.querySelectorAll('a[href]')].filter((anchor) => anchor !== direct);
    if (pathKey(readUrl(href)?.pathname) === '/collections/all' && children.length && children.every((anchor) => pathKey(readUrl(anchor.getAttribute('href'))?.pathname) === '/collections/all')) return 'marken';
    const text = (direct?.textContent || item.querySelector(':scope > button')?.textContent || '').trim().toLocaleLowerCase(locale);
    return ['damen', 'herren', 'kinder', 'bekleidung', 'schuhe', 'ausrustung', 'activity', 'marken', 'sale'].find((key) => ui(key).toLocaleLowerCase(locale) === text) || '';
  };
  const setText = (element, value) => {
    const decoded = decodeHtmlEntities(value);
    if (element && decoded && element.textContent !== decoded) element.textContent = decoded;
  };
  const localize = (scope = document) => {
    refreshUI();
    const anchors = [...scope.querySelectorAll('.ps-mega a[href], .f-drawer-mobile-nav a[href], [data-peakstyle-category-navigation] a[href]')];
    if (scope.matches?.('.ps-mega, .f-drawer-mobile-nav, [data-peakstyle-category-navigation]')) anchors.push(...scope.querySelectorAll('a[href]'));
    [...new Set(anchors)].forEach((anchor) => {
      const original = anchor.getAttribute('href');
      const translated = collection(original);
      const next = url(original);
      if (next && original !== next) anchor.setAttribute('href', next);
      if (anchor.dataset.psLocalizedLabel === 'true' || anchor.matches('.ps-mega__all-link, .ps-mobile-menu__all-link') || anchor.closest('.ps-mega__category-group--all')) return;
      let text = translated?.label;
      const saleHeading = anchor.dataset.psSaleGroup;
      if (saleHeading) text = ui(saleHeading);
      const saleGroup = anchor.closest('.ps-mega__category-group');
      if (!saleHeading && saleGroup?.querySelector('[data-ps-sale-group="by_audience"]')) {
        const targetAudience = audience(original);
        if (targetAudience) {
          text = ui(targetAudience) + ' · ' + ui('sale');
          anchor.dataset.psFixedAudience = 'true';
        }
      }
      if (anchor.closest('.ps-mega__sale-discount-grid')) {
        if (readUrl(original)?.searchParams.get('sort_by') === 'price-ascending') text = ui('unique_pieces');
        else if (translated?.handle === 'sale-25') text = ui('all_offers');
      }
      if (!text) return;
      if (anchor.matches('.ps-mega__brand-tile')) {
        if (anchor.getAttribute('aria-label') !== text) anchor.setAttribute('aria-label', text);
        const image = anchor.querySelector('img');
        if (image && image.alt !== text) image.alt = text;
      } else if (anchor.matches('.ps-mega__visual')) setText(anchor.querySelector('strong'), text);
      else if (anchor.matches('.ps-mega__activity-card')) setText(anchor.querySelector('span:last-child'), text);
      else if (anchor.matches('.ps-mega__brand-link')) {
        setText(anchor, text);
        anchor.dataset.brandName = text;
      } else if (anchor.querySelector(':scope > span')) setText(anchor.querySelector(':scope > span'), text);
      else setText(anchor, text);
    });
  };
  window.PeakStyleNavigationI18n = { locale, ui, collection, label, url, node, tree, branchKey, localize };
  document.addEventListener('DOMContentLoaded', () => localize(document), { once: true });
  document.addEventListener('shopify:section:load', () => localize(document));
  document.addEventListener('click', (event) => {
    const anchor = event.target.closest?.('.ps-mega a[href], .f-drawer-mobile-nav a[href], [data-peakstyle-category-navigation] a[href]');
    if (!anchor) return;
    const original = anchor.getAttribute('href');
    const next = url(original);
    if (next && next !== original) anchor.setAttribute('href', next);
  }, true);
})();
